import csLogo from '#/assets/Hitachi-energy-mark.svg'
import styles from './Logo.module.css'
import { useLogoNavigationLink } from '#/state'

export const Logo = () => {
  const { logoNavigationLinkDisabled } = useLogoNavigationLink()

  const logoImage = <img src={csLogo} className={styles.for_logo_one} aria-hidden="true" alt="Hitachi Energy logo" />

  return (
    <>
      {logoNavigationLinkDisabled && <a className={styles.linkWrapper}>{logoImage}</a>}
      {!logoNavigationLinkDisabled && (
        <a href="/" className={styles.linkWrapper}>
          {logoImage}
        </a>
      )}
    </>
  )
}
